// extracted by mini-css-extract-plugin
export default {"layout":"communication-hub_layout__hUsEH","tabsList":"communication-hub_tabsList__HakJ9","tabTrigger":"communication-hub_tabTrigger__HlpDW","icon":"communication-hub_icon__RWBON"};